import {
  CHARCOAL_GREY,
  PLAIN_GREY,
  GRAY_LIGHT_2,
  TEXT_SUBHEADER,
  VERTICAL_SEPARATOR,
  GRAY_ACTIVE_SELECTION,
  LIGHT_BLUE,
  combinedColor,
  OPACITY_MEDIUM,
} from '~/Constants/Colors.constants';
import { FONT_SIZE_INBETWEEN, FONT_SIZE_SMALL, FONT_SIZE_SMALLISH } from '~/Constants/UI.constants';
import { makeStyles } from '~/UIKit/Style';

export const FitoListItemStyles = ({
  isBeingRearranged,
  status,
  hasCheckBox,
  active,
}: {
  isBeingRearranged: boolean;
  hasCheckBox: boolean;
  status: boolean;
  active?: boolean;
}) =>
  makeStyles(
    (theme) => ({
      listItemContainer: {
        backgroundColor: active ? GRAY_ACTIVE_SELECTION : 'white',
        color: PLAIN_GREY,
        cursor: isBeingRearranged ? 'move' : 'pointer',
        borderBottom: `thin solid ${VERTICAL_SEPARATOR}`,
        display: 'flex',
        '& > div': {
          padding: '14px 16px',
          columnGap: '8px',
        },
      },
      listItem: {
        width: hasCheckBox ? 'calc(100% - 60px)' : '100%',
        display: 'flex',
        flexGrow: 1,

        '& .MuiListItem-root': {
          alignItems: 'start',
          paddingTop: theme.spacing(2),
          paddingBottom: theme.spacing(2),
        },
      },
      ListItemAvatar: {
        minWidth: 0,
        marginRight: 8,
        '& .MuiAvatar-colorDefault': {
          color: CHARCOAL_GREY,
          backgroundColor: LIGHT_BLUE,
        },
        '& .MuiSvgIcon-root': {
          fontSize: '16px',
        },
      },
      listItemText: {
        margin: 0,
        whiteSpace: 'nowrap',
        '& .MuiListItemText-primary': {
          fontSize: '16px',
          lineHeight: '20px',
          fontWeight: 'bold',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
        '& .MuiListItemText-secondary': {
          fontSize: '14px',
          lineHeight: '20px',
          fontWeight: 300,
          color: TEXT_SUBHEADER,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          height: status ? 30 : 20,
          display: status ? 'flex' : 'block',
          alignItems: status && 'center',
          columnGap: status && '0.8rem',
        },
      },
      listItemSecondaryAction: {
        height: 30,
        top: '26px',
      },
      menuItem: {
        fontSize: FONT_SIZE_INBETWEEN,
      },
      listItemMenuButton: {
        padding: 3,
      },
      dateWrapper: {
        fontSize: FONT_SIZE_SMALLISH,
        color: GRAY_LIGHT_2,
        opacity: '50%',
        display: 'grid',
        marginTop: 4,
        justifyContent: 'space-between',
      },
      date: {
        fontSize: FONT_SIZE_SMALL,
        color: combinedColor(GRAY_LIGHT_2, OPACITY_MEDIUM),
        margin: 0,
      },
      secondaryListItemAction: {
        position: 'relative',
        height: 60,
        display: 'flex',
        right: 4,
        top: 0,
        transform: 'none',
        alignItems: 'center',
      },
    }),
    { name: 'FitoListItem' },
  );
